import PropTypes from 'prop-types';

import { HAND_HOLDING_BOWL_ICON_URL } from 'honeydew/icons/PlusMembership';
import Popover from 'honeydew/Popover';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import { getResizedCDNAsset } from 'utils/globalUtils';

import BenefitBase from './shared/BenefitBase';

function DonateMeals({ layout }) {
    const { plusMembershipBranding } = useAccountPlusMembershipHook();

    const horizontalImage = (
        <img
            src={getResizedCDNAsset({ url: HAND_HOLDING_BOWL_ICON_URL, width: 300 })}
            alt="ribbon with coin"
            width={150}
        />
    );

    const verticalImage = (
        <img
            src={getResizedCDNAsset({ url: HAND_HOLDING_BOWL_ICON_URL, width: 200 })}
            alt="ribbon with coin"
            width={100}
        />
    );

    const headline = (
        <>
            Each order helps provide 2+ meals to people facing hunger{' '}
            <Popover trigger="ⓘ" heading="How does this work?" label="How does Feeding America work?">
                <span className="text-body-xs">
                    $1 helps Feeding America to provide at least 10 meals. For each {plusMembershipBranding} order
                    placed, 25 cents will be donated to Feeding America beginning July 8, 2024 and ending December 31,
                    2025. Donations to Feeding America are helping provide food and groceries to the Feeding America
                    network of food banks.
                </span>
            </Popover>
        </>
    );

    return (
        <BenefitBase
            headline={headline}
            verticalImage={verticalImage}
            horizontalImage={horizontalImage}
            horizontalImagePosition="bottom-[-20px] left-0 right-[-30px] top-[-20px]"
            layout={layout}
        />
    );
}

DonateMeals.propTypes = {
    layout: PropTypes.oneOf(['horizontal', 'responsive']),
};

DonateMeals.defaultProps = {
    layout: 'responsive',
};

export default DonateMeals;
